<template>
	<div>
		<q-btn-dropdown :label="getClientLabel" icon="fal fa-building" flat class="q-mr-sm" v-model="show_clients" v-if="user_clients.length > 1">
			<q-list link>
				<q-item v-for="(item, index) in user_clients" :key="index" v-if="id_user_client_selected != item.id" @click.native="changeClient(item)">
					<q-item-main>
						<q-item-tile label>
							{{ item.name }}
						</q-item-tile>
					</q-item-main>
				</q-item>
			</q-list>
		</q-btn-dropdown>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	data(){
		return{
			show_clients: false,
		}
	},
	computed:{
		...mapGetters({
			access_token: 'common/access_token',
			user_clients: 'common/user_clients',
			clients: "params/clients",
			user_countries: 'common/user_countries',
			id_user_client_selected: 'common/id_user_client_selected',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			id_user_language_selected: 'common/id_user_language_selected',
			user_module_items: 'common/user_module_items',
			reload_content: 'common/reload_content',
		}),

		getClientLabel() {
            let obj = this.user_clients.find((obj) => { return obj.id == this.id_user_client_selected })
            if (obj) return obj.name
            else return ''
		},

		getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },
	},

	methods:{
		changeClient(item) {
      this.$store.dispatch('common/SET_CLIENT', [item.id])
			this.show_clients = !this.show_clients
			
		},
	},
}
</script>

<style>
</style>
